import axios from 'axios'
import { GroupResponse } from '../../common/GroupResponse'

type Props = {
  contactGroup: any
  redirectPath: string
}

export const createContactGroup = async (props: Props) => {
  const { contactGroup: group } = props
  return await axios.post<GroupResponse>(
    `${process.env.REACT_APP_API_URL}/contactGroup`,
    group,
    {
      withCredentials: true,
    },
  )
}
